import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import StepProgressBar from './StepProgressBar';

const PaymentDetailsModal = ({ show, onHide, onNext, onBack, selectedMode, currentStep }) => {
  const [amountPaid, setAmountPaid] = useState('');
  const [paymentMode, setPaymentMode] = useState('Cash On Hand');

  const invoiceData = [
  {
    id: 1,
    invoiceNo: 'Opening Balance',
    invDate: '15-Oct-25',
    age: '0 days',
    invAmount: '₹20,000.00',
    paidSoFar: '-',
    prevDue: '₹20,000.00',
    paying: '-',
    newDue: '-',
    isOpeningBalance: true
  }
  // Add more invoice items here
];

  const handleContinue = () => {
    if (amountPaid) {
      onNext({ amountPaid, paymentMode });
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
      <Modal.Header className="border-0 pb-0">
        <div className="w-100">
          
          {/* Header Content */}
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div>
              <h5 className="mb-0 fw-bold fs-5">Step 2 of 3: Add Payment Out</h5>
              <small className="text-muted">Select an option from the below list</small>
            </div>
            <Button variant="link" onClick={onBack} className="p-0 text-secondary">
              <FaTimes size={20} />
            </Button>
          </div>
          {/* Progress Bar */}
          {/* <StepProgressBar currentStep={currentStep} totalSteps={3} /> */}
        </div>
      </Modal.Header>
      
      <Modal.Body className="pt-2">
        {/* Distributor Info */}
        <div className="d-flex align-items-center mb-4 gap-2">
          <div 
            className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center"
            style={{ width: '50px', height: '50px', fontSize: '18px', fontWeight: 'bold' }}
          >
            SA
          </div>
          <div className="flex-grow-1">
            <h6 className="mb-0 fw-bold" style={{fontSize:16}}>Sample Distributor</h6>
            <small className="text-muted fw-bold">GSTIN:</small>
          </div>
          <div className="d-flex text-end gap-3">
            <div className="d-flex flex-column">
            <div className="text-success fw-bold fs-5">₹0.00</div>
            <small className="text-muted fw-bold">Prev Balance</small>
            </div>
            <div className="d-flex flex-column">
              <div className="text-success fw-bold fs-5">₹0.00</div>
              <small className="text-muted fw-bold">New Balance</small>
            </div>
          </div>
        </div>

        {/* Payment Form */}
        <div className="row mb-4">
          <div className="col-12 col-md-12 col-lg-6">
            <Form.Group>
              <Form.Label className="fw-bold">
                AMOUNT PAID OUT <span className="text-danger">*</span>
              </Form.Label>
              <div className="input-group">
                <span className="input-group-text bg-white">₹</span>
                <Form.Control
                  type="text"
                  placeholder="Enter Amount here"
                  value={amountPaid}
                  onChange={(e) => setAmountPaid(e.target.value)}
                  className="border-start-0"
                />
              </div>
            </Form.Group>
          </div>
          <div className="col-12 col-md-12 col-lg-6">
            <Form.Group>
              <Form.Label className="fw-bold">
                PAYMENT MODE <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                value={paymentMode}
                onChange={(e) => setPaymentMode(e.target.value)}
                style={{width:'100%'}}
              >
                <option>Cash On Hand</option>
                <option>Paid-Out Cheque</option>
                <option>Bank Transfer</option>
              </Form.Select>
            </Form.Group>
          </div>
        </div>

        {/* Invoice Table Headers */}
        <div className="mb-4">
  <div className="table-responsive" style={{height:'200px'}}>
    <table className="table table-hover mb-0">
      <thead style={{ backgroundColor: '#2f3c4c' }}>
  <tr>
    <th style={{ width: '50px', borderTop: 'none', backgroundColor: '#2f3c4c' }}>
      <Form.Check type="checkbox" />
    </th>
    <th style={{ borderTop: 'none', backgroundColor: '#2f3c4c' }}>
      <small className="text-uppercase fw-bold text-white">INVOICE NO</small>
    </th>
    <th style={{ borderTop: 'none', backgroundColor: '#2f3c4c' }}>
      <small className="text-uppercase fw-bold text-white">INV DATE</small>
    </th>
    <th style={{ borderTop: 'none', backgroundColor: '#2f3c4c' }}>
      <small className="text-uppercase fw-bold text-white">AGE</small>
    </th>
    <th style={{ borderTop: 'none', backgroundColor: '#2f3c4c' }}>
      <small className="text-uppercase fw-bold text-white">INV AMT</small>
    </th>
    <th style={{ borderTop: 'none', backgroundColor: '#2f3c4c' }}>
      <small className="text-uppercase fw-bold text-white">PAID</small>
    </th>
    <th style={{ borderTop: 'none', backgroundColor: '#2f3c4c' }}>
      <small className="text-uppercase fw-bold text-white">PREV DUE</small>
    </th>
    <th style={{ borderTop: 'none', backgroundColor: '#2f3c4c' }}>
      <small className="text-uppercase fw-bold text-white">PAYING</small>
    </th>
    <th style={{ borderTop: 'none', backgroundColor: '#2f3c4c' }}>
      <small className="text-uppercase fw-bold text-white">DUE</small>
    </th>
  </tr>
</thead>

      <tbody>
        {invoiceData.map((invoice) => (
          <tr key={invoice.id}>
            <td>
              <Form.Check type="checkbox" />
            </td>
            <td>
              <span className={invoice.isOpeningBalance ? 'fw-medium' : ''}>
                {invoice.invoiceNo}
              </span>
            </td>
            <td>
              <span className="text-muted">{invoice.invDate}</span>
            </td>
            <td>
              <span className="text-muted">{invoice.age}</span>
            </td>
            <td>
              <span className="fw-medium">{invoice.invAmount}</span>
            </td>
            <td className="text-center">
              <span>{invoice.paidSoFar}</span>
            </td>
            <td>
              <span className={invoice.prevDue !== '-' ? 'fw-medium text-danger' : ''}>
                {invoice.prevDue}
              </span>
            </td>
            <td className="text-center">
              <span>{invoice.paying}</span>
            </td>
            <td className="text-center">
              <span>{invoice.newDue}</span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  
  {/* Show empty state only if no data */}
  {invoiceData.length === 0 && (
    <div className="text-center py-3">
      <div className="mb-4">
        <div className="empty-state-illustration">
          <div className="empty-box">
            <div className="empty-papers"></div>
            <div className="empty-person"></div>
          </div>
        </div>
      </div>
      <p className="text-muted fs-6">We've Plenty Of Space For Your Data, We Promise!</p>
    </div>
  )}
</div>
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0">
        <div className="w-100 d-flex justify-content-between align-items-center">
          <Button variant="outline-secondary" onClick={onBack}>
            ← Back
          </Button>
          
          <Button 
            className='gradient-dark-button' 
            onClick={handleContinue}
            disabled={!amountPaid}
          >
            Continue
          </Button>
        </div>
      </Modal.Footer>

      <style jsx>{`
        .input-group-text {
          border-right: 0;
        }
        .border-start-0 {
          border-left: 0 !important;
        }
        .border-start-0:focus {
          border-left: 0 !important;
          box-shadow: none;
        }
        kbd {
          background-color: #e9ecef;
          color: #495057;
          padding: 0.2rem 0.4rem;
          border-radius: 0.25rem;
          font-size: 0.8rem;
        }
          .form-select{
          width:100% !important;
          height:40px
          }
        
        /* Empty State Illustration */
        .empty-state-illustration {
          width: 300px;
          height: 200px;
          margin: 0 auto;
          position: relative;
          opacity: 0.6;
        }
        
        .empty-box {
          width: 120px;
          height: 100px;
          background: linear-gradient(145deg, #f5f5f5, #e8e8e8);
          border-radius: 8px;
          position: absolute;
          left: 50%;
          top: 30%;
          transform: translateX(-50%);
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        }
        
        .empty-papers {
          width: 80px;
          height: 60px;
          background: white;
          border-radius: 4px;
          position: absolute;
          top: 15px;
          left: 20px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        
        .empty-person {
          width: 40px;
          height: 60px;
          background: #ddd;
          border-radius: 20px 20px 0 0;
          position: absolute;
          right: -30px;
          top: 40px;
        }
      `}</style>
    </Modal>
  );
};


export default PaymentDetailsModal;